/**
 * DMS document attachments API.
 * Generic, entity-type agnostic endpoints at /v4/attachments.
 */

import { api } from '@/lib/api';
import type { Attachment, AttachmentEntityType } from './types';

export const getAttachments = (entityType: AttachmentEntityType, entityId: string) =>
  api.get<Attachment[]>('/v4/attachments', {
    entity_type: entityType,
    entity_id: entityId,
  });

export const createAttachment = (data: {
  entity_type: AttachmentEntityType;
  entity_id: string;
  document_id: string;
}) => api.post<Attachment>('/v4/attachments', data);

export const deleteAttachment = (id: string) => api.delete(`/v4/attachments/${id}`);
